// Import the necessary functions and components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TimelineItem from "examples/Timeline/TimelineItem";
import { useEffect, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { elapsedTime } from "utils/date";
import { getLast5DaysAttendance } from "framework/students/attendance";
import { format } from "date-fns";

function AttendanceHistory({ admissionNo }) {
  const [attendanceData, setAttendanceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState(null);

  async function fetchLast5DaysAttendance() {
    if (attendanceData.length === 0) {
      try {
        setIsLoading(true);
        const last5DaysAttendance = await getLast5DaysAttendance(admissionNo);
        setAttendanceData(last5DaysAttendance);
      } catch (error) {
        console.error(error);
        setErr("Failed to get last 5 days' attendance, try refreshing.");
      } finally {
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    fetchLast5DaysAttendance();
    const intervalId = setInterval(fetchLast5DaysAttendance, 1000 * 60);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Card sx={{ height: "100%", position: "relative" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Attendance History
        </MDTypography>
      </MDBox>
      {!isLoading && (
        <MDBox py={2} px={4}>
          {(err || attendanceData?.length === 0) && (
            <MDTypography variant="body" align="center" px={3} sx={{ fontSize: "0.9rem" }}>
              {err ?? "No attendance history for the last 5 days."}
            </MDTypography>
          )}
          {!err &&
            attendanceData?.length !== 0 &&
            attendanceData.map((attendanceEntry, index) => (
              <TimelineItem
                key={index} // Replace with the appropriate key
                color="success"
                icon="calendar_today"
                title={`Attendance Marked on ${format(attendanceEntry.time.toDate(), 'MM/dd/yyyy')}`}
                dateTime={elapsedTime(attendanceEntry.time.toDate())}
              />
            ))}
        </MDBox>
      )}
      <Backdrop open={isLoading} sx={{ position: "absolute", borderRadius: "0.75rem" }}>
        <CircularProgress />
      </Backdrop>
    </Card>
  );
}

export default AttendanceHistory;